<template>
    <div class="about-social-corp" v-if="pageSetup != null" id="social-corp">
        <div class="container">
            <div class="section-title-new">
                <h2>{{ pageSetup.about_social.section_title }}</h2>
            </div>
            <div class="social-head">
                <div class="column-container">
                    <div class="col-left" v-if="!isMobileChecker">
                        <div class="col-img"><img :src="pageSetup.about_social.corp.img" alt=""></div>
                    </div>
                    <div class="col-right">
                        <h3>{{ pageSetup.about_social.corp.title }}</h3>
                        <p v-html="pageSetup.about_social.corp.desc"></p>
                        <div class="col-img col-img-mobile" v-if="isMobileChecker"><img :src="pageSetup.about_social.corp.img" alt=""></div>
                        <div class="unique-desc">
                            <img :src="pageSetup.about_social.corp.icon" alt="">
                            <strong v-html="pageSetup.about_social.corp.desc_red"></strong>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column-desc-info">
                <div class="column-container">
                    <div class="col-left">
                        <div class="desc-col" v-html="pageSetup.about_social.corp.desc_left"></div>
                    </div>
                    <div class="col-right">
                        <div class="desc-col" v-html="pageSetup.about_social.corp.desc_right"></div>
                    </div>
                </div>
            </div>
            <aboutSocialPriority></aboutSocialPriority>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import aboutSocialPriority from '@/components/about-page/about-priority.vue'
    export default {
        name: 'about-social-corp-section',
        components: {
            aboutSocialPriority,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            pageSetup: 'loadAboutPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            startLoader() {
                // this.$parent.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about-page/about-social-corp.scss';
    @import '@/styles/components/about-page/respond/about-social-corp-respond.scss';
</style>